import React, { useEffect, useState, useMemo } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import {
  AiOutlineEye,
  AiOutlineDownload,
  AiOutlineDelete,
} from "react-icons/ai";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { Select, Spin, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { LoadingOutlined } from "@ant-design/icons";
import { RxCross2 } from "react-icons/rx";
import { DatePicker } from "antd";
import dayjs from "dayjs"; // For handling date values
import Instance from "../../AxiosConfig";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";

const AddNewRenewCertification = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [scopeOfWork, setScopeOfWork] = useState("");
  const [clientName, setClientName] = useState("");
  const [standard, setStandard] = useState("");
  const [email, setEmail] = useState("");
  const [firstSurveillanceAudit, setFirstSurveillanceAudit] = useState("");
  const [secondSurveillanceAudit, setSecondSurveillanceAudit] = useState("");
  const [firstSurveillanceStatus, setFirstSurveillanceStatus] = useState([]);
  const [secondSurveillanceStatus, setSecondSurveillanceStatus] = useState([]);
  const [firstSurveillanceNotes, setFirstSurveillanceNotes] = useState("");
  const [secondSurveillanceNotes, setSecondSurveillanceNotes] = useState("");
  const [certificationNumber, setCertificationNumber] = useState("");
  const [status, setStatus] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [expiryDate, setExpiryDate] = useState("");
  const [registrationDate, setRegistrationDate] = useState("");
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [showFileDownloadToast, setShowFileDownloadToast] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [alternateEmailInput, setAlternateEmailInput] = useState("");
  const [alternateEmails, setAlternateEmails] = useState([]);
  const [certificationList, setCertificationList] = useState([]);
  const [selectedCertification, setSelectedCertification] = useState(null);
  const [renewalNumber, setRenewalNumber] = useState("");

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleChange = (info) => {
    if (info.file.status === "done" || info.file.status === "uploading") {
      const file = info.file.originFileObj;
      if (file) {
        setLogoFile(file);
        setImageUrl(URL.createObjectURL(file));
      }
    }
  };
  const uploadButton = (
    <div>
      <MdOutlineFileUpload size={28} />
      <div style={{ marginTop: 8 }}>Upload Logo</div>
    </div>
  );

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    addFiles(files);
  };
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const navigate = useNavigate();
  const fetchAgentData = async () => {
    // const token = localStorage.getItem("token");
    try {
      const response = await Instance.get(
        "/agents"
        //   {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      console.log(response);
      if (response.status == 200 || response.status == 201) {
        setAgentData(response?.data?.agents);
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  const fetchAllCertifications = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await Instance.get("/Certification/get", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        const certifications = response.data?.certifications || [];
        setCertificationList(certifications);
      }
    } catch (error) {
      console.error("Error fetching certifications:", error);
    }
  };

  const handleFetchCertificationDetails = async () => {
    if (!selectedCertification) {
      message.warning("Please select a certification first!");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await Instance.get(
        `/Certification/get/${selectedCertification}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        const data = response.data?.certification;
        if (data) {
          // Set all your form fields with the fetched data
          setCompanyName(data.companyName || "");
          setAddress(data.address || "");
          setRegistrationDate(data.dateOfRegistration || "");
          setExpiryDate(data.certificationExpiryDate || "");
          setScopeOfWork(data.scopeOfWork || "");
          setClientName(data.clientName || "");
          setStandard(data.standard || "");
          setEmail(data.email || "");
          setFirstSurveillanceAudit(data.firstSurveillanceAudit || "");
          setSecondSurveillanceAudit(data.secondSurveillanceAudit || "");
          setCertificationNumber(data.certificationNumber || "");
          setStatus(data.status || "");
          setSelectedAgents(data.assignedAgent.agentName || []);
          setFirstSurveillanceStatus(data.firstSurveillanceStatus || "");
          setSecondSurveillanceStatus(data.secondSurveillanceStatus || "");
          setFirstSurveillanceNotes(data.firstSurveillanceNotes || "");
          setSecondSurveillanceNotes(data.secondSurveillanceNotes || "");
          setSelectedCountry(
            data.country ? { label: data.country, value: data.country } : null
          );
          setCity(data.city || "");
          setPhone(data.companyPhoneNumber || "");
          setAlternateEmails(data.alternateEmails || []);
          setImageUrl(data.logo || null);
          fetchRenewalNumber(data._id);
        }
      }
    } catch (error) {
      console.error("Error fetching certification details:", error);
      message.error("Failed to load certification details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchRenewalNumber = async (certificationId) => {
    if (!certificationId) return;

    try {
      const token = localStorage.getItem("token");
      const response = await Instance.get(`/renewal`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 || response.status === 201) {
        const histories = response.data?.histories || [];

        console.log("Selected Certification ID:", certificationId);
        console.log("Histories:", histories);

        // find match
        const match = histories.find(
          (item) => item.certificationId === certificationId
        );

        if (match && match.cycleNumber !== undefined) {
          console.log("Matched Cycle Number:", match.cycleNumber);
          setRenewalNumber(match.cycleNumber.toString());
        } else {
          setRenewalNumber("");
        }
      }
    } catch (error) {
      console.error("Error fetching renewal number:", error);
    }
  };

  useEffect(() => {
    fetchAgentData();
    fetchAllCertifications();
  }, []);

  const AgentOptions = agentData.map((agent) => ({
    label: agent.agentName,
    value: agent._id,
  }));

  const countryOptions = useMemo(() => countryList().getData(), []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    addFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const addFiles = (files) => {
    const newFiles = files.map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + " Kb",
      date: new Date().toLocaleDateString(),
      file: file,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  useEffect(() => {
    if (showSuccessMsg) {
      const timer = setTimeout(() => setShowSuccessMsg(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessMsg]);

  const clearAllFields = () => {
    setCompanyName("");
    setAddress("");
    setRegistrationDate("");
    setExpiryDate("");
    setScopeOfWork("");
    setClientName("");
    setStandard("");
    setEmail("");
    setFirstSurveillanceAudit("");
    setSecondSurveillanceAudit("");
    setCertificationNumber("");
    setStatus([]);
    setSelectedAgents([]);
    setUploadedFiles([]); // clear attachments
    setLogoFile(null); // clear logo
    setAlternateEmails([]);
    setAlternateEmailInput("");
    setSelectedCountry(null);
    setPhone("");
    setCity("");
    setFirstSurveillanceStatus([]);
    setSecondSurveillanceStatus([]);
    setFirstSurveillanceNotes("");
    setSecondSurveillanceNotes("");
    setImageUrl(null);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");

    if (!selectedCertification) {
      message.warning("Please select a certification before saving!");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        certificationId: selectedCertification,
        dateOfRegistration: registrationDate || "",
        certificationExpiryDate: expiryDate || "",
        firstSurveillanceAudit: firstSurveillanceAudit || "",
        secondSurveillanceAudit: secondSurveillanceAudit || "",
        firstSurveillanceStatus: firstSurveillanceStatus || "",
        secondSurveillanceStatus: secondSurveillanceStatus || "",
        firstSurveillanceNotes: firstSurveillanceNotes || "",
        secondSurveillanceNotes: secondSurveillanceNotes || "",
        cycleNumber: renewalNumber || "",
      };

      const response = await Instance.post("/renewal", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log(response, "asdf");
      if (response.status === 200 || response.status === 201) {
        message.success("Renewal details saved successfully!");
        clearAllFields();
        navigate("/certification");
      }
    } catch (error) {
      console.error("Error saving renewal:", error.response || error.message);
      message.error("Failed to save renewal details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {showSuccessMsg && (
        <div className="success-alert d-flex justify-content-between align-items-center">
          <span> certification details Uploaded successfully!</span>
          <span className="close-icon" onClick={() => setShowSuccessMsg(false)}>
            ×
          </span>
        </div>
      )}

      {showDeleteToast && (
        <div className="download-toast">
          <span>Certification details discarded successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDeleteToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      <div className="company-form mt-4 p-4">
        <div className="details-page">
          <ImgCrop rotationSlider aspect={1} shape="round" quality={1}>
            <Upload
              name="logo"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={({ onSuccess }) =>
                setTimeout(() => onSuccess("ok"), 0)
              } // disable auto-upload
              onChange={handleChange}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Company Logo"
                  className="profile-img-preview"
                  draggable={false}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </ImgCrop>
        </div>
      </div>
      <div className="company-form mt-4">
        {/* Your existing form fields */}

        <div className="row mt-2">
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Select Certification
            </label>
            <Select
              className="custom-multi-select"
              placeholder="Select Certification"
              options={certificationList.map((cert) => ({
                value: cert._id,
                label: cert.certificationNumber || "Unnamed Certification",
              }))}
              value={selectedCertification}
              onChange={(value) => setSelectedCertification(value)}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-lg-2 mt-4 d-flex align-items-end">
            <button
              type="button"
              className="save-btn"
              style={{
                backgroundColor: "#127285",
                border: "none",
                color: "#fff",
                padding: "8px 20px",
                borderRadius: "6px",
                fontWeight: 500,
                fontSize: "15px",
                transition: "0.3s ease",
              }}
              onClick={handleFetchCertificationDetails}
            >
              OK
            </button>
          </div>
        </div>

        <div className="row ">
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Company Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Company Name"
              value={companyName}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Agent</label>
            <Select
              className="custom-multi-select"
              options={AgentOptions}
              style={{ width: "100%" }}
              placeholder="select Agent"
              value={selectedAgents}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Renewal number</label>
            <input
              className="input-placeholder form-control"
              type="number"
              placeholder="Enter Renewal Number"
              value={renewalNumber}
              onChange={(e) => setRenewalNumber(e.target.value)}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Standard</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Standard"
              value={standard}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Address</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Address"
              value={address}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Country</label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Country"
              options={countryOptions.map((c) => ({
                label: c.label,
                value: c.value,
              }))}
              value={selectedCountry?.value}
              readOnly
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Phone</label>
            <PhoneInput
              defaultCountry="in"
              value={phone}
              readOnly
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">City</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter city"
              value={city}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Client Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Client Name"
              value={clientName}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Email</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Email"
              value={email}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Alternate Emails</label>
            <div
              className="form-control d-flex flex-wrap align-items-center"
              style={{ minHeight: "38px" }}
            >
              {alternateEmails.map((email, index) => (
                <span
                  key={index}
                  className="badge bg-primary me-2 mb-1 d-flex align-items-center"
                  style={{ fontSize: "0.85rem" }}
                >
                  {email}
                  <button
                    type="button"
                    onClick={() =>
                      setAlternateEmails(
                        alternateEmails.filter((_, i) => i !== index)
                      )
                    }
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: "0.6rem" }}
                  ></button>
                </span>
              ))}

              <input
                type="text"
                value={alternateEmailInput}
                onChange={(e) => setAlternateEmailInput(e.target.value)}
                onKeyDown={(e) => {
                  if (["Enter", ","].includes(e.key)) {
                    e.preventDefault();
                    const email = alternateEmailInput.trim();
                    if (email && !alternateEmails.includes(email)) {
                      setAlternateEmails([...alternateEmails, email]);
                      setAlternateEmailInput("");
                    }
                  }
                }}
                placeholder="Add alternate email and press Enter"
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  minWidth: "150px",
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Date of Registration
            </label>
            <DatePicker
              className="form-control input-placeholder"
              value={registrationDate ? dayjs(registrationDate) : null}
              onChange={(date) =>
                setRegistrationDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Surveillance Audit
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={
                firstSurveillanceAudit ? dayjs(firstSurveillanceAudit) : null
              }
              onChange={(date) =>
                setFirstSurveillanceAudit(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Survielence Audit Status
            </label>
            <Select
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Pending", label: "Pending" },
                { value: "Completed", label: "Completed" },
              ]}
              value={firstSurveillanceStatus}
              onChange={(value) => setFirstSurveillanceStatus(value)}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Surveillance Audit
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={
                secondSurveillanceAudit ? dayjs(secondSurveillanceAudit) : null
              }
              onChange={(date) =>
                setSecondSurveillanceAudit(
                  date ? date.format("YYYY-MM-DD") : ""
                )
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Survielence Audit Status
            </label>
            <Select
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Pending", label: "Pending" },
                { value: "Completed", label: "Completed" },
              ]}
              value={secondSurveillanceStatus}
              onChange={(value) => setSecondSurveillanceStatus(value)}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Expiry Date
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={expiryDate ? dayjs(expiryDate) : null}
              onChange={(date) =>
                setExpiryDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Number
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Certification Number"
              value={certificationNumber}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Status</label>
            <Select
              // mode="multiple"
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Active", label: "Active" },
                { value: "Inactive", label: "Inactive" }, // fix here
              ]}
              value={status}
              readOnly
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">Scope of Work</label>
          <textarea
            className="input-placeholder form-control"
            placeholder="Enter scope of work..."
            rows={4} // height of the textarea
            value={scopeOfWork}
            readOnly
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            1st Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            placeholder="1st Survelliance Audit Notes"
            rows={4} // height of the textarea
            value={firstSurveillanceNotes}
            onChange={(e) => setFirstSurveillanceNotes(e.target.value)}
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            2nd Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            placeholder="2nd Survelliance Audit Notes"
            rows={4} // height of the textarea
            value={secondSurveillanceNotes}
            onChange={(e) => setSecondSurveillanceNotes(e.target.value)}
          />
        </div>

        {/* Upload Section */}
        {/* <div className="attachment-upload mt-4">
          <label className="input-label form-label">Attachment</label>
          <div
            className="upload-box"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <input
              id="fileInput"
              type="file"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <p
              className="upload-text"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Drag and Drop Attachment here or{" "}
              <span className="upload-link">click to Upload</span>{" "}
              <span className="upload-icon">
                <MdOutlineFileUpload />
              </span>
            </p>
          </div>
        </div> */}

        {/* File Details Table */}
        {/* {uploadedFiles.length > 0 && (
          <div className="table-responsive">
            <table className="file-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Size</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {uploadedFiles.map((file, index) => (
                  <tr key={index}>
                    <td>{file.name}</td>
                    <td>{file.size}</td>
                    <td>{file.date}</td>
                    <td className="file-actions">
                      
                      <AiOutlineEye
                        className="action-icon"
                        onClick={() => {
                          const fileURL = URL.createObjectURL(file.file);
                          setModalImageSrc(fileURL);
                          setShowModal(true);
                        }}
                      />

                       
                      <AiOutlineDownload
                        className="action-icon"
                        onClick={() => {
                          setShowFileDownloadToast(true);
                          setTimeout(
                            () => setShowFileDownloadToast(false),
                            3000
                          );

                          const url = URL.createObjectURL(file.file);
                          const link = document.createElement("a");
                          link.href = url;
                          link.download = file.name;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);
                        }}
                      />

                       
                      <AiOutlineDelete
                        className="action-icon"
                        onClick={() =>
                          setUploadedFiles((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )} */}

        {showFileDownloadToast && (
          <div className="download-toast">
            <span>Certification Downloaded Successfully</span>
            <button
              className="toast-close-btn"
              onClick={() => setShowFileDownloadToast(false)}
            >
              <RxCross2 size={18} />
            </button>
          </div>
        )}

        {showModal && (
          <div
            className="image-modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {modalImageSrc?.endsWith(".pdf") ? (
                <iframe
                  src={modalImageSrc}
                  title="PDF Preview"
                  width="100%"
                  height="500px"
                />
              ) : (
                <img
                  src={modalImageSrc}
                  alt="Preview"
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              )}
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end gap-3 mt-4">
          <button
            className="discard-btn"
            onClick={() => navigate("/certification")}
          >
            Discard
          </button>

          <button className="save-btn" onClick={handleSubmit}>
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "#fff" }}
                    spin
                  />
                }
              />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNewRenewCertification;
